// TODO should be removed in future; or rename, "Group" unclear
enum Group {
  STUDENTS = 'students',
  COACHES = 'coaches',
  DRAFTS = 'drafts',
  ALL = 'all',
}

export default Group;
